module.exports = __webpack_public_path__ + "img/mitrex_and_cladify_logo.546e5620.png";